// Programa de indicação (28/10/2026). O código de quem indicou chega pelo link mágico /i/<código> ou por ?ref=<código>
// (links antigos dos e-mails), fica guardado neste navegador por 30 dias e entra sozinho no cadastro.
// Quem se cadastra com ele ganha 10% na 1ª consulta; quem indicou ganha um cupom de 10% quando a pessoa paga a
// primeira consulta (backend/src/services/referralProgram.js).
import { safeGetItem, safeSetItem, safeRemoveItem } from "@/lib/safeStorage";

const KEY = "blink_referral";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

export const REFERRAL_PERCENT = 10;

export function normalizeReferralCode(raw: string | null | undefined): string {
  return String(raw || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 20);
}

/** Guarda o código (devolve o código normalizado, ou null se não parece um código). */
export function storeReferralCode(raw: string | null | undefined): string | null {
  const code = normalizeReferralCode(raw);
  if (code.length < 4) return null;
  safeSetItem(KEY, JSON.stringify({ code, at: Date.now() }));
  return code;
}

export function getStoredReferralCode(): string | null {
  try {
    const raw = safeGetItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw);
    if (!v?.code || Date.now() - Number(v.at || 0) > TTL_MS) { safeRemoveItem(KEY); return null; }
    return normalizeReferralCode(v.code) || null;
  } catch { return null; }
}

export function clearStoredReferralCode(): void {
  safeRemoveItem(KEY);
}

/** ?ref=<código> na URL de entrada (links antigos dos e-mails de indicação). Chamado uma vez ao abrir o site. */
export function captureReferralFromUrl(): void {
  try {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) storeReferralCode(ref);
  } catch { /* navegador sem URLSearchParams/storage: segue sem código */ }
}
